import React from 'react';
import { Shimmer } from '../../Shimmer/Shimmer';
import { Accordion } from './Accordion';
import { MarginProps } from '../../../../theme/styledProps';

export const AccordionLoading = (props: MarginProps) => {
  return (
    <Accordion isActive={false} {...props}>
      <Shimmer width={175} height={32} m="16" />
    </Accordion>
  );
};
